export * from './lib/article-modal-feature-shell.module';
